import * as Dialog from '@radix-ui/react-dialog';
import { NavLink } from 'react-router';
import { Close, ArrowUpRight } from '@/icons';
import { mainNav } from '@/data/navigation';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function MobileMenu({ open, onOpenChange }: Props) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-bg/95 z-50 backdrop-blur-sm" />
        <Dialog.Content
          className="fixed inset-0 z-50 bg-bg flex flex-col p-6 overflow-y-auto"
          onEscapeKeyDown={() => onOpenChange(false)}
        >
          <div className="flex justify-between items-center mb-14">
            <Dialog.Title className="font-display font-black text-2xl">JUST SEE</Dialog.Title>
            <Dialog.Close aria-label="Close" className="p-2 -mr-2 cursor-pointer">
              <Close className="w-6 h-6" />
            </Dialog.Close>
          </div>
          <nav className="flex flex-col gap-6">
            {mainNav.map((item) => (
              <NavLink
                key={item.href}
                to={item.href}
                className="font-display text-5xl font-medium hover:text-accent transition-colors"
                onClick={() => onOpenChange(false)}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="mt-auto pt-12 flex flex-col gap-4">
            <a
              href="mailto:business@justsee-ltd.com"
              className="inline-flex items-center gap-2 self-start font-sans text-lg underline underline-offset-4"
            >
              business@justsee-ltd.com <ArrowUpRight className="w-4 h-4" />
            </a>
            <a
              href="tel:+35795904930"
              className="inline-flex items-center gap-2 self-start font-sans text-lg underline underline-offset-4"
            >
              +35795904930 <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
